import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import PartnerStepperTemplate from '../../components/partnermng/PartnerStepperTemplate';

const PartnerAddContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState({ name: "거래처 신규 추가" });
  const handleGoBack = () => {
    navigate('/partnermng');
  };

  return (
    <>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="마스터/거래처 관리/추가"
        menuLink="/partnermng"
        icon="partner"
        titleData={titleData}
      />
      <Box
        sx={{
          mt: 2
        }}
      >
         <PartnerStepperTemplate />
      </Box>
     
    </>
  );
};

export default PartnerAddContainer;
